import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import {
  setOverbookingFlag,
  setRescheduleFlag,
  setSelectedOverBooking,
  setSelectedSlotDetails,
  setSelectedSlotStaffDetails,
  setSelectedSlotsClinicDetails,
  setSlotBookingFilters,
  setSlotsList,
} from "@/app_redux/reducers/slices/auth/slots_slice";
import { useEffect } from "react";
import { Outlet } from "react-router";
import { IAtHomeServicesPageProps } from "./interface";

const AtHomeServicesPage: React.FC<IAtHomeServicesPageProps> = (_props) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      setSlotBookingFilters({
        filters: null,
      }),
    );
    dispatch(
      setSelectedSlotStaffDetails({
        data: null,
      }),
    );
    dispatch(
      setSelectedSlotsClinicDetails({
        data: null,
      }),
    );
    dispatch(
      setSelectedSlotDetails({
        data: null,
      }),
    );
    dispatch(setOverbookingFlag(false));
    dispatch(setRescheduleFlag(false));
    dispatch(
      setSelectedSlotsClinicDetails({
        data: null,
      }),
    );
    dispatch(
      setSelectedOverBooking({
        data: null,
      }),
    );
    dispatch(
      setSelectedSlotStaffDetails({
        data: null,
      }),
    );
    dispatch(
      setSlotsList({
        data: null,
      }),
    );
  }, []);

  return <Outlet />;
};

export default AtHomeServicesPage;

